<div class="pseudo-dialog">
  <div class="pseudo-dialog-content">
    @if (variables$ | async; as variables) {
      <app-variable-menu-item-selector
        [items]="variables"
        [parentTextKey]="'GROUPS.TAXONOMY' | translate"
        (variableMenuItemSelected)="variableMenuItemSelected($event)"
      ></app-variable-menu-item-selector>
    }
  </div>
  <div class="actions">
    <div>
      <button mat-stroked-button (click)="close()">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="add()" [disabled]="!chosenVariableMenutItem">
        {{ 'COMMON.ACTION_LABELS.ADD' | translate }}
      </button>
    </div>
  </div>
</div>
